import React from 'react'
import { defineMessages } from 'react-intl'
import { ModalClose } from 'src/Components/shared/Modal'
import { If, Modal, Text, Player } from 'src/Components'
import BotHeadColored from 'src/Components/shared/Avatar/BotHeadColored'
import CMASection from 'src/Components/shared/EstimatedValue/CMASection'

import styles from './WarningModal.module.scss'

const MESSAGES = defineMessages({
  diffWarningTitle: {
    id: 'Homeowner.avmDiffWarning.title',
    defaultMessage: 'Why did my home value fluctuate so much?'
  },
  diffWarningBody: {
    id: 'Homeowner.avmDiffWarning.body',
    defaultMessage:
      "The value of your home has changed more than expected in the last month. But don't worry, automated valuations are only a computer's best guess based on the information available. However, no one understands the value of your home better than a human real estate agent. Click on the button below, answer some brief questions and we will send that information to your agent for review. Once your agent has updated the value of your home, it will be reflected in your monthly home report."
  },
  nonDisclosureTitle: {
    id: 'Homeowner.nonDisclosureState.title',
    defaultMessage: 'What does it mean to live in a non-disclosure state?'
  },
  nonDisclosureBody: {
    id: 'Homeowner.nonDisclosureState.body',
    defaultMessage:
      'Your state limits the amount of information Homebot can access and this can create an accuracy issue.'
  }
})

const DiffWarningVideo = ({ intl }) =>
  intl.locale === 'en' ? (
    <Player.wistia
      videoId='kzsvbkye7q'
      className={styles.padVideo}
      title={intl.formatMessage(MESSAGES.diffWarningTitle)}
    />
  ) : (
    <div className={styles.disclosureText}>
      {intl.formatMessage(MESSAGES.diffWarningBody)}
    </div>
  )

const NonDisclosureVideo = ({ intl }) =>
  intl.locale === 'en' ? (
    <Player.wistia
      videoId='1dfkdhj7bh'
      className={styles.padVideo}
      title={intl.formatMessage(MESSAGES.nonDisclosureTitle)}
    />
  ) : (
    <div className={styles.disclosureText}>
      {intl.formatMessage(MESSAGES.nonDisclosureBody)}
    </div>
  )

const WarningModal = ({
  intl,
  toggle,
  showAVMDiffWarning,
  showNonDisclosureStateWarning
}) => (
  <Modal
    openKey='homeowner.showWarningModal'
    toggle={toggle}
    type='quiet'
    className={styles.modal}
    size='l'
    overrideContent
  >
    <Text
      element='h3'
      size='xl'
      weight='light'
      align='center'
      className={styles.headline}
    >
      <BotHeadColored size='xs' className={styles.bothead} />
      {intl.formatMessage(
        MESSAGES[showAVMDiffWarning ? 'diffWarningTitle' : 'nonDisclosureTitle']
      )}
    </Text>

    <If condition={showAVMDiffWarning}>
      <DiffWarningVideo intl={intl} />
    </If>
    <If condition={showNonDisclosureStateWarning}>
      <NonDisclosureVideo intl={intl} />
    </If>
    <div className={styles.cmaSection}>
      <CMASection close={toggle} />
    </div>
    <ModalClose toggle={toggle} />
  </Modal>
)

export default WarningModal
